import React from "react";

export function ClubManagementPage() {
  return (
    <div className="page-container">
      <div className="content">
        <h1>🏢 Club Management</h1>
        <p>Manage clubs and club administrators across the system.</p>
        <p style={{ color: "#7f8c8d", marginTop: "20px", fontSize: "14px" }}>
          Coming soon...
        </p>
      </div>
    </div>
  );
}
